import store from '@/store';
import BotService from '@/services/BotService';
import { Integration } from '@/models';
import { OmniChatSchema } from '@omnichat/omnichat-model';

export interface BotState {
  bots: Integration[];
  bot: Integration;
  loading: boolean;
  defaultTeamId: string | undefined;
  defaultTradingHours: any | undefined;
}

export const BotModule: {
  state: BotState,
  mutations: any,
  actions: any,
} = {
  state: {
    bots: [],
    bot: null as any,
    defaultTeamId: undefined,
    loading: false,
    defaultTradingHours: undefined
  },
  mutations: {
    setBots(state: BotState, bots: Integration[]) {
      state.bots = bots;
    },
    setBot(state: BotState, bot: Integration) {
      state.bot = bot;
    },
    setBotsLoading(state: BotState, loading: boolean) {
      state.loading = loading;
    },
    addBot(state: BotState, bot: Integration) {
      state.bots.push(bot);
    },
    deleteBot(state: BotState, botId: string) {
      const bot = state.bots.filter((c) => c.objectId !== botId);
      state.bots = bot;
    },
    updateBot(state: BotState, bot: Integration) {
      const index = state.bots.findIndex((c) => c.objectId === bot.objectId);
      if (index !== -1) {
        state.bots[index] = { ...state.bots[index], ...bot };
      }
    },
    setBotDefaultTeamId(state: BotState, defaultTeamId: string | undefined) {
      state.defaultTeamId = defaultTeamId;
    },
    setBotDefaultTrandingHours(state: BotState, defaultTradingHours: string | undefined) {
      state.defaultTradingHours = defaultTradingHours;
    }
    
  },
  actions: {
    async loadBots({ commit }: any) {
      commit('setBotsLoading', true);
      commit('setBots', []);
      const result = await BotService.getAllBots(store.state.auth.currentUser)
        .catch((error) => {
          commit('setBotsLoading', false);
          throw error;
        });
      commit('setBots', result.results);
      commit('setBotsLoading', false);
    },
    async loadBotById({ commit }: any, botIntegrationId: string) {
      const result = await BotService.getBotById(store.state.auth.currentUser, botIntegrationId);
      commit('setBot', result);
    },
    async loadBotDefaultTeam({ commit }: any) {
      try {
        const response = await BotService.loadBotDefaultTeam();
        commit('setBotDefaultTeamId', response && response.result ? response.result.teamId : undefined);
      } catch (error) {}
    },
    async createBot({ commit }: any, payload: OmniChatSchema.BotStateMachine) {
      const bot = await BotService.createBot(payload);
      commit('addBot', bot);
      return bot && bot.objectId;
    },
    async deleteBot({ commit }: any, botId: string) {
      await BotService.deleteBot(botId);
      commit('deleteBot', botId);
    },
    async updateBot({ commit }: any, bot: Integration) {
      await BotService.updateBot(bot.objectId as string, bot);
      commit('setBot', bot);
    },
    async saveBot({ commit }: any, bot: Integration) {
      await BotService.updateBot(bot.objectId as string, bot);
    },
    async convertToV2({ commit }: any, bot: Integration) {
      await BotService.convertToV2(bot);
    },
    async inactivateBot({ commit }: any) {
      await BotService.inactivateBot();
    },
    async loadBotDefaultTrandingHours({ commit }: any) {
      try {
        const response = await BotService.loadBotDefaultTrandingHours();
        
        commit('setBotDefaultTrandingHours', response && response.result ? response.result.tradingHours : undefined);
      } catch (error) {}
    },
  },
};
